import { UserStore } from "../../../plugins/auth/model/UserStore";
import { GlobalLocation } from "../../../application/GeoLocation";
export class GeoQualifier {
    constructor() {
        this.key = "Geo";
    }
    process() {
        return this.getUserZipCodes();
    }
    getUserZipCodes() {
        const user = UserStore.getUser();
        // 1. Logged-in user zip codes — comma-separated, mirrors ConneXt v2 User.getUserZipCodes()
        if (user && Array.isArray(user.ZipCodes) && user.ZipCodes.length > 0) {
            const zips = user.ZipCodes
                .filter(Boolean)
                .map((z) => z.toString().replace(/\s/g, ""));
            if (zips.length > 0)
                return zips.join(",");
        }
        // 2. Geo location zip
        const geoZip = GlobalLocation.getZipCode();
        if (geoZip && geoZip !== "unknown") {
            return geoZip.replace(/\s/g, "");
        }
        return "unknown";
    }
}
